var TrilliumFormHelpers = (function ($) {
    var trilliumFormHelpersSelector = '.tri-form-helper';
    var setHiddenFieldOnClickSelector = '.set-hidden-field';
    var setHiddenFieldOnClickDropdownSelector = '.dropdown-set-hidden-field';
    var ipdTraineeDetailsFormSubmitButton = '.ipd-trainee-details-form-submit-button';
    var formSubmitButtonSelector = '.set-loading-spinner-elem';
    var setLoadingSpinnerVisibilityOnSubmitFormSelector = '.set-loading-spinner-form';
    var clearFieldAndDisableSelector = '.tri-clear-and-disable-field';
    var setHiddenElementVisibilityElement = '.set-visibility-element';
    var setHiddenElementVisibilityOnClickElement = '.set-visibility-element-on-click';
    var setSwitchingElementVisibilityOnClickElement = '.switch-visibility-element-on-click';
    var setToggleFormFieldsValidation = '.set-toggle-form-fields-validation';
    var formSubmitButton = '.form-submit-button';
    var triggerFieldValidationSelector = '.trigger-field-validation-selector';
    var setValidateTranslatedCertificateUpload = '.set-validate-translated-certificate-upload';
    var validateSelfOnChange = '.validate-self-on-change';
    var eligibleLevelDropdown = '.eligible-level-dropdown';
    var setToggleDisabledElemOnChangeSelector = '.set-toggle-disabled-elem';
    var setHiddenFieldOnChangeSelector = '.set-hidden-field-on-change';

    var bindChevronClick = function () {
        var nameChevron = $('.name-chevron');
        var dateChevron = $('.date-chevron');

        if (nameChevron.length) {
            nameChevron.on("click", function (e) {
                e.preventDefault();
                var elem = $(this);

                dateChevron.removeClass('active');
                dateChevron.addClass('inactive');

                elem.removeClass('inactive');

                if (!elem.hasClass('active')) {
                    elem.addClass('active');
                }

                if (elem.hasClass('asc')) {
                    elem.removeClass('asc');
                    elem.addClass('desc');

                    // update query param
                    var href = elem.attr('href').replace('asc', 'desc');
                    elem.attr('href', href);
                } else if (elem.hasClass('desc')) {
                    elem.removeClass('desc');
                    elem.addClass('asc');

                    // update query param
                    var href = elem.attr('href').replace('desc', 'asc');
                    elem.attr('href', href);
                }
            });

            dateChevron.on("click", function (e) {
                e.preventDefault();
                var elem = $(this);

                nameChevron.removeClass('active');
                nameChevron.addClass('inactive');

                elem.removeClass('inactive');

                if (!elem.hasClass('active')) {
                    elem.addClass('active');
                }

                if (elem.hasClass('asc')) {
                    elem.removeClass('asc');
                    elem.addClass('desc');

                    // update query param
                    var href = elem.attr('href').replace('asc', 'desc');
                    elem.attr('href', href);
                } else if (elem.hasClass('desc')) {
                    elem.removeClass('desc');
                    elem.addClass('asc');

                    // update query param
                    var href = elem.attr('href').replace('desc', 'asc');
                    elem.attr('href', href);
                }
            });
        }
    }

    var bindDateSortArrowClick = function () {
        var sortArrow = $('.sort-arrow-binder');
        if (sortArrow.length) {
            sortArrow.on('click', function () {
                var parent = document.getElementById('evidence-comments-rev-wrap');
                if (parent != null && parent.children != null) {
                    for (var i = 1; i < parent.childNodes.length; i++) {
                        parent.insertBefore(parent.childNodes[i], parent.firstChild);
                    }

                    var elem = $(this);
                    if (elem.hasClass('sort-arrow-down')) {
                        elem.removeClass('sort-arrow-down');
                    }
                    else {
                        elem.addClass('sort-arrow-down');
                    }
                }
            });
        }
    }

    var bindDisabledToggleElemOnChange = function () {
        if ($(setToggleDisabledElemOnChangeSelector).length) {
            $(setToggleDisabledElemOnChangeSelector).each(function () {
                var elem = $(this);
                var disabledToggleTarget = elem.data("disabled-toggle-target");
                if (disabledToggleTarget !== null && disabledToggleTarget !== undefined) {
                    var targetElem = $(disabledToggleTarget);
                    if (targetElem.length) {
                        elem.on("change", function () {
                            targetElem.removeClass('disabled');
                            targetElem.prop("disabled", false);
                        });
                    }
                }
            });
        }
    }

    var bindValidateSelfOnChange = function () {
        if ($(validateSelfOnChange).length) {
            $(validateSelfOnChange).each(function () {
                var elem = $(this);
                elem.change(function () {
                    $(this).valid();
                });
            });
        }
    }

    var bindIpdTraineeDetailsFormSubmitButton = function () {
        if ($(trilliumFormHelpersSelector).length && $(ipdTraineeDetailsFormSubmitButton).length) {
            var elem = $(ipdTraineeDetailsFormSubmitButton);
            var targetFormSelector = elem.data("submit-form-target");

            if (targetFormSelector !== null && targetFormSelector !== undefined) {
                var targetForm = $(targetFormSelector);
                if (targetForm !== undefined && targetForm !== null) {
                    elem.on("click", function (e) {
                        if (targetForm.valid()) {
                            var validateMentor = $(this).data("validate-mentor-id");
                            if (validateMentor === 'True') {
                                var mentorIdElement = $('.searched-mentor-id');
                                // .searched-mentor-id is only present on mentor information page and this is where the model value of the searched mentor is set
                                // assume that if no .searched-mentor-id element is present then the currently rendered partial is the mentor search form
                                if (mentorIdElement.length) {
                                    var mentorId = mentorIdElement.val();
                                    if (mentorId !== "") {
                                        targetForm.submit();
                                    }
                                }
                                else {
                                    var mentorErrorMessageElement = $('.mentor-id-error');
                                    var mentorDelegateTemdataMessage = $('.mentor-delegate-tempdata-warning-message');
                                    if (mentorDelegateTemdataMessage.length) {
                                        mentorDelegateTemdataMessage.hide();
                                    }

                                    if (mentorErrorMessageElement.length) {
                                        mentorErrorMessageElement.show();
                                    }
                                    else {
                                        mentorErrorMessageElement.hide();
                                    }
                                }
                            }
                            else {
                                targetForm.submit();
                            }
                        }
                    });
                }
            }
        }
    }

    var bindHiddenFieldOnChange = function () {
        if ($(trilliumFormHelpersSelector + setHiddenFieldOnChangeSelector).length) {
            $(trilliumFormHelpersSelector + setHiddenFieldOnChangeSelector).each(function () {
                var elem = $(this);
                var target = elem.data("bind-target");
                if (target !== null && target !== undefined) {
                    var targetElem = $(target);
                    if (targetElem !== undefined && targetElem !== null) {
                        elem.on("change", function () {
                            var value = elem.val();
                            if (value !== null && value !== undefined) {
                                targetElem.val(value);
                            }
                        });
                    }
                }
            });
        }
    };

    var bindHiddenFieldOnClick = function () {
        if ($(trilliumFormHelpersSelector + setHiddenFieldOnClickSelector).length) {
            $(trilliumFormHelpersSelector + setHiddenFieldOnClickSelector).each(function () {
                var elem = $(this);
                var target = elem.data("bind-target");
                var value = elem.data("bind-value");
                if (target !== null && target !== undefined &&
                    value !== null && value !== undefined) {
                    var targetElem = $(target);
                    if (targetElem !== undefined && targetElem !== null) {
                        elem.on("click", function () {
                            targetElem.val(value);
                        });
                    }
                }
            });
        }
    };

    var bindHiddenFieldOnDropdownSelection = function () {
        if ($(trilliumFormHelpersSelector + setHiddenFieldOnClickDropdownSelector).length) {
            $(trilliumFormHelpersSelector + setHiddenFieldOnClickDropdownSelector).each(function () {
                var elem = $(this);
                var target = elem.data("bind-target");
                elem.change(function () {
                    var selectedText = $(this).find("option:selected").text();;
                    if (target !== null && target !== undefined) {
                        var targetElem = $(target);
                        if (targetElem !== undefined && targetElem !== null) {
                            targetElem.val(selectedText);
                        }
                    }
                });
            });
        }
    }

    var bindTriggerSingleFieldValidation = function () {
        if ($(trilliumFormHelpersSelector + triggerFieldValidationSelector).length) {
            $(trilliumFormHelpersSelector + triggerFieldValidationSelector).each(function () {
                var elem = $(this);
                var validateTarget = elem.data("validate-target");

                elem.change(function () {
                    if (validateTarget !== null && validateTarget !== undefined) {
                        var targetElem = $(validateTarget);
                        if (targetElem !== undefined && targetElem !== null) {
                            targetElem.valid();
                        }
                    }
                });
            });
        }
    }

    var bindShowLoadingSpinnerOnFormSubmit = function () {
        if ($(trilliumFormHelpersSelector + setLoadingSpinnerVisibilityOnSubmitFormSelector).length && $(formSubmitButtonSelector).length) {
            $(setLoadingSpinnerVisibilityOnSubmitFormSelector).submit(function () {
                if ($(this).valid()) {
                    TrilliumLoadingComponent.showFullScreenLoading();
                    //$(formSubmitButtonSelector).html('<span class="spinner-border spinner-border-sm text-white disabled" role="status" aria-hidden="true"></span>');
                    $(formSubmitButtonSelector).addClass('disabled');
                    $(formSubmitButtonSelector).attr('disabled', 'true');
                }
            });
        }
    };

    var bindClearFieldAndDisableOnChange = function () {
        if ($(trilliumFormHelpersSelector).length && $(clearFieldAndDisableSelector).length) {
            $(trilliumFormHelpersSelector).find(clearFieldAndDisableSelector).on("change", function () {
                clearFieldAndDisableOnChange($(this), false);
            });

            var elemts = $(trilliumFormHelpersSelector).find(clearFieldAndDisableSelector);

            elemts.each(function () {
                clearFieldAndDisableOnChange($(this), true);
            });
        }
    };

    var clearFieldAndDisableOnChange = function (elem, init) {
        var targetClassSelector = elem.data("cfd-target-selector");
        var targetAttribute = elem.data("cfd-target-attribute");
        var selectedValue = elem.val();

        var targetElements = $(targetClassSelector);
        if (targetElements.length > 0) {
            targetElements.each(function () {
                var tElem = $(this);
                var tElemAttributeValue = tElem.data(targetAttribute);

                if (tElemAttributeValue !== null || tElemAttributeValue !== undefined) {
                    if (tElemAttributeValue === selectedValue) {
                        tElem.parent().show();
                        tElem.removeClass('disabled');
                        tElem.prop("disabled", false);
                        if (init === false) {
                            tElem.prop("checked", false);
                        }
                    }
                    else {
                        tElem.parent().hide();
                        tElem.addClass('disabled');
                        tElem.prop("disabled", true);
                        tElem.prop("checked", false);
                    }
                }
            });
        }
    };

    var scrollToTopSubmittedForm = function (formSelector) {
        var scrolling = false;

        if (!formSelector) {
            formSelector = "#ajax-form-wrapper";
        }

        var wrapper = jQuery(formSelector).first();

        if (wrapper.children().length > 0 && wrapper.children()[0].className.includes('no-focus')) {
            wrapper = document.getElementById("focused-el");
        }

        if (wrapper.length && scrolling === false) {
            scrolling = true;
            setTimeout(function () {
                $('html, body').animate({
                    scrollTop: wrapper.offset().top
                }, 1100, function () { scrolling = false; });
            },
                200);
        }
    };

    var scrollToOffsetTopSubmittedForm = function (formSelector) {
        var scrolling = false;

        if (!formSelector) {
            formSelector = "#ajax-form-wrapper";
        }

        var wrapper = jQuery(formSelector).first();

        if (wrapper.length && scrolling === false) {
            scrolling = true;
            setTimeout(function () {
                $('html, body').animate({
                    scrollTop: wrapper.offset().top
                }, 1100, function () { scrolling = false; });
            }, 200);
        }
    };

    var bindVisibilityToggleElemOnChange = function () {
        if ($(setHiddenElementVisibilityElement).length) {
            $(setHiddenElementVisibilityElement).each(function () {
                var elem = $(setHiddenElementVisibilityElement);
                var setVisibilitytarget = elem.data("set-visibility-target");
                if (setVisibilitytarget !== null && setVisibilitytarget !== undefined) {
                    var targetElem = $(setVisibilitytarget);
                    if (targetElem !== undefined && targetElem !== null) {
                        elem.on("change", function () {
                            if (!targetElem.hasClass('d-none')) {
                                targetElem.addClass('d-none');
                            } else if (targetElem.hasClass('d-none')) {
                                targetElem.removeClass('d-none');
                            }
                        });
                    }
                }
            });
        }
    };

    var bindQualificationAimEligiblityOnChange = function () {
        if ($(eligibleLevelDropdown).length) {
            var elem = $(eligibleLevelDropdown);
            var warningMessageTarget = elem.data("warning-message-target");

            const EligibleLevels = {
                'c031a83f-f211-eb11-a813-000d3a86ac4e': 3, // CEng
                '3c32a83f-f211-eb11-a813-000d3a86ac4e': 2, // IEng
                '6bd7a245-f211-eb11-a813-000d3a86ac4e': 1, // EngTech
                '8ea1908d-c0d8-eb11-bacb-00224800ffe8': 0, // None
            };

            Object.freeze(EligibleLevels);

            if (warningMessageTarget !== null && warningMessageTarget !== undefined) {
                var targetElem = $(warningMessageTarget);
                if (targetElem !== undefined && targetElem !== null) {
                    elem.change(function () {
                        var currentEligibleLevel = elem.data("eligible-level");
                        var selectedEligibleLevel = $(this).val();

                        // find this Guid in the object and get number value
                        var eligibleNumberValue = EligibleLevels[currentEligibleLevel];
                        var selectedNumberValue = EligibleLevels[selectedEligibleLevel];

                        if (eligibleNumberValue !== undefined && eligibleNumberValue !== null
                            && selectedNumberValue !== undefined && selectedNumberValue !== null) {
                            if (selectedNumberValue > eligibleNumberValue) {
                                if (targetElem.hasClass('d-none')) {
                                    targetElem.removeClass('d-none');
                                }
                            }
                            else {
                                if (!targetElem.hasClass('d-none')) {
                                    targetElem.addClass('d-none');
                                }
                            }
                        }
                    });
                }
            }
        }
    };

    var bindVisibilityToggleElemOnClick = function () {
        if ($(setHiddenElementVisibilityOnClickElement).length) {
            $(setHiddenElementVisibilityOnClickElement).each(function () {
                var elem = $(setHiddenElementVisibilityOnClickElement);
                var setVisibilitytarget = elem.data("set-visibility-target");
                if (setVisibilitytarget !== null && setVisibilitytarget !== undefined) {
                    var targetElem = $(setVisibilitytarget);
                    if (targetElem !== undefined && targetElem !== null) {
                        elem.change(function () {
                            if ($(this).val() === 'True') {
                                if (!targetElem.hasClass('d-none')) {
                                    targetElem.addClass('d-none');
                                }
                            } else {
                                if (targetElem.hasClass('d-none')) {
                                    targetElem.removeClass('d-none');
                                }
                            }
                        });
                    }
                }
            });
        }
    };

    //var bindSwitchingVisibilityToggleElemOnClick = function () {
    //    if ($(setSwitchingElementVisibilityOnClickElement).length) {
    //        $(setSwitchingElementVisibilityOnClickElement).each(function () {
    //            var elem = $(setSwitchingElementVisibilityOnClickElement);
    //            var setVisibilitytargetVisible = elem.data("set-visibility-target-visible");
    //            var setVisibilitytargetInVisible = elem.data("set-visibility-target-invisible");
    //            if (setVisibilitytargetVisible !== null && setVisibilitytargetVisible !== undefined && setVisibilitytargetInVisible !== null && setVisibilitytargetInVisible !== undefined ) {
    //                var targetElemVisible = $(setVisibilitytargetVisible);
    //                var targetElemInVisible = $(setVisibilitytargetInVisible);
    //                if (targetElemVisible !== undefined && targetElemVisible !== null & targetElemInVisible !== undefined && targetElemInVisible !== null) {
    //                    elem.change(function () {
    //                        if (targetElemVisible.hasClass('d-none')) {
    //                            targetElemVisible.removeClass('d-none');
    //                        }
    //                        if (!targetElemInVisible.hasClass('d-none')) {
    //                            targetElemInVisible.addClass('d-none');
    //                        }
    //                    });
    //                }
    //            }
    //        });
    //    }
    //};

    var bindToggleRequiredTranslatedCertificateUpload = function () {
        if ($(setValidateTranslatedCertificateUpload).length) {
            var elem = $(setValidateTranslatedCertificateUpload);
            var toggleValidationClassTarget = elem.data("set-validation-class-target");

            if (toggleValidationClassTarget !== null && toggleValidationClassTarget !== undefined) {
                var targetElem = $(toggleValidationClassTarget);
                if (targetElem !== undefined && targetElem !== null) {
                    elem.change(function () {
                        if ($(this).val() === 'True') {
                            if (!targetElem.hasClass('upload-completed')) {
                                targetElem.addClass('upload-completed');
                            }
                        } else {
                            if (targetElem.hasClass('upload-completed')) {
                                targetElem.removeClass('upload-completed');
                            }
                        }
                    });
                }
            }
        }
    }

    // disable GiftAid address form validation on page load - this form is hidden by default
    // this form validation is enabled by checking a gift aid checkbox
    var disableGiftAidAddressFormValidation = function () {
        if ($('.donation-step-form').length && $('.giftaid-address-form').length) {
            var donationStepFormSettings = $.data($('.donation-step-form').get(0), 'validator').settings;

            if (donationStepFormSettings) {
                donationStepFormSettings.ignore = ".donation-step-form-field";
                $('.donation-step-form').valid();
            }
        }
    };

    var bindAnnualAppraisalFormSubmissionCPDHoursValidation = function () {
        var form = $('.trainee-annual-appraisal-form');

        if (form.length) {
            var formSettings = $.data(form.get(0), 'validator').settings;
            var submitButton = $('.ipdAppraisalSubmitButton');

            submitButton.each(function () {
                var elem = $(this);
                elem.on("click", function () {
                    var submitValue = elem.val();
                    if (submitValue == "draft") {

                        if (formSettings) {
                            formSettings.ignore = ".cpd-hours-form-field";
                            form.valid();
                        }

                    }
                });
            });
        }
    }

    var SponsorAttributeDisplayToggle = function () {
        $(".attributeDefinitionSelect").on("change", function () {
            var selectedAttribute = $(this).val();
            var selectedAttributeClass = "." + selectedAttribute;
            var parent = $(this).closest(".attributeContainer");

            var SelectedAttribute = parent.find(selectedAttributeClass);
            var attributes = parent.find(".attributeDefinition");

            attributes.each(function () {
                if (!$(this).hasClass("d-none")) {
                    $(this).addClass("d-none");
                }
            });

            SelectedAttribute.removeClass("d-none");
        });
    };

    var toggleGiftaidFormValidation = function () {
        var giftaidAddressForm = $('.giftaid-address-form');
        var donationStepForm = $('.donation-step-form');
        var setToggleFormFieldsValidationCheckbox = $(setToggleFormFieldsValidation);

        if (giftaidAddressForm.length && donationStepForm.length && setToggleFormFieldsValidationCheckbox.length) {
            var formSettings = $.data(donationStepForm.get(0), 'validator').settings;

            setToggleFormFieldsValidationCheckbox.on("change", function () {
                if (setToggleFormFieldsValidationCheckbox.is(":checked")) {
                    formSettings.ignore = "";
                }
                else {
                    formSettings.ignore = ".donation-step-form-field";
                    $('.donation-step-form').valid();
                }
            });
        }
    };

    var bindFormSubmitButton = function () {
        if ($(trilliumFormHelpersSelector).length && $(formSubmitButton).length) {
            var elem = $(formSubmitButton);
            var targetFormSelector = elem.data("submit-form-target");

            if (targetFormSelector !== null && targetFormSelector !== undefined) {
                var targetForm = $(targetFormSelector);
                if (targetForm !== undefined && targetForm !== null) {
                    elem.on("click", function (e) {
                        var validateFileUpload = ValidateFileUploadForm($(this));

                        if (targetForm.valid() && validateFileUpload === true) {
                            targetForm.submit();
                        }
                    });
                }
            }
        }
    }

    function ValidateFileUploadForm(elem) {
        var validateUploadTarget = elem.data("validate-upload-target");
        var validateUploadRequired = elem.data("validate-upload-required");

        if ($(validateUploadTarget).length > 0 && validateUploadRequired === true) {
            var elemts = $(validateUploadTarget);
            var allUploaded = [];

            elemts.each(function () {
                var element = $(this);
                if (element.hasClass('upload-completed')) {
                    allUploaded.push(true);
                }
                else {
                    allUploaded.push(false);

                    var alertMessageTarget = element.data("alert-message-target");
                    var taregtAlertClassName = `.${alertMessageTarget}`;

                    if ($(taregtAlertClassName).length) {
                        $(taregtAlertClassName).show();
                    }
                }
            });

            if (allUploaded.includes(false)) {
                if (window.TrilliumFormHelpers !== undefined) {
                    TrilliumFormHelpers.scrollToTopSubmittedForm(".ajax-form-validate-all");
                }
                return false;
            }
            else {
                return true;
            }
        }

        return true;
    }

    var unbindVisibilityToggleElemOnChange = function () {
        if ($(setHiddenElementVisibilityElement).length) {
            $(setHiddenElementVisibilityElement).each(function () {
                var elem = $(setHiddenElementVisibilityElement);
                var setVisibilitytarget = elem.data("set-visibility-target");
                if (setVisibilitytarget !== null && setVisibilitytarget !== undefined) {
                    var targetElem = $(setVisibilitytarget);
                    if (targetElem !== undefined && targetElem !== null) {
                        elem.off("change");
                    }
                }
            });
        }
    };

    var printInfo = function () {
        if ($(".printBtn").length) {
            $(".printBtn").on("click", function () {
                window.print();
            });
        }
    };

    var toggleReducedRateForm = function () {
        if ($(".toggleReducedRateForm").length) {
            $(".toggleReducedRateForm").on("click", function () {
                if ($(this).is(":checked")) {
                    $(".reducedRateForm").removeClass("d-none");
                }
                else {
                    if (!$(".reducedRateForm").hasClass("d-none")) {
                        $(".reducedRateForm").addClass("d-none");
                    }
                }
            });
        }
    }

    var academicAssessmentHelper = function () {
        if ($(".card-assessment-clickable").length > 0) {
            $(".card-assessment-clickable").off("click");
            $(".card-assessment-clickable").on("click", function () {
                var target = $(this).data("target");

                if (target == undefined) {
                    console.warn("No target detected");
                }
                else {
                    if ($("." + target).length) {
                        $("." + target).click();
                    }
                }
            });
        }
    }

    var groupClickHelper = function () {
        if ($(".card-group-clickable").length > 0) {
            $(".card-group-clickable").off("click");
            $(".card-group-clickable").on("click", function () {
                var target = $(this).data("target");

                if (target == undefined) {
                    console.warn("No target detected");
                }
                else {
                    if ($("." + target).length) {
                        $("." + target).click();
                    }
                }
            });
        }
    }

    var customProgressCircle = function () {
        if ($(".custom-progress").length) {
            var parent = $(".custom-progress");

            var attributeLevelsElement = parent.find('.attribute-levels-data');

            if (attributeLevelsElement.length) {
                var levels = attributeLevelsElement.data('attribute-levels-total');
                var levels_complete = attributeLevelsElement.data('attribute-levels-completed');

                var value = Math.round(levels_complete / levels * 100);

                if (value > 100) {
                    value = 100;
                } else if (value < 0) {
                    value = 0;
                }

                var circle = parent.find('#bar');
                var attributeLevels = parent.find('#attribute_levels');

                if (circle != null && attributeLevels != null) {
                    var r = circle.attr('r'),
                        c = Math.PI * r * 2,
                        pct = ((100 - value) / 100) * c;

                    circle.animate({ 'stroke-dashoffset': pct });
                    attributeLevels.html('<span class="">' + levels_complete + '</span>/' + levels);
                }
            }
        }
    };

    var disableRightClickOnLink = function () {
        $(document).ready(function () {
            $(".rightClickDisable").on('contextmenu', function (e) {
                e.preventDefault();
            });
            $(".mouseWheelClickDisable").on('auxclick',function (e) {
                e.preventDefault();
            });
        });
            
    };

    var OptionalPostCodeFormValidation = function (formId,requiredMsg,InvalidCharMsg,CodeMaxLengthMsg) {
        var refMsg = "";
        $(`#${formId}`).on("submit", function (e) {
            var postcode = $("#PostalCode");
            var postcodeVal = postcode.val();
            var validationMessage = "";
            if (postcodeVal != undefined) {
                if (postcodeVal == "") {
                    validationMessage = requiredMsg;
                } else {
                    let emailRegExp = new RegExp(/^\w+((\-|\s)\w+)*$/);
                    let flg = emailRegExp.test(postcodeVal);
                    if (!flg) {
                        validationMessage = InvalidCharMsg;
                    } else if (postcodeVal.length > 16) {
                        validationMessage = CodeMaxLengthMsg;
                    }
                }

                var validationFields = $(".field-validation-valid");
                if (validationFields.length > 0) {
                    if (refMsg != validationMessage) {
                        refMsg = validationMessage;
                        $(".field-validation-valid").each(function () {
                            var forVal = $(this).attr("data-valmsg-for");
                            if (forVal == "OptionalPostCode") {
                                this.innerHTML = `<span class='field-validation-error' data-valmsg-for='PostCode' data-valmsg-replace='true'><span>${validationMessage}</span></span>`;
                            }
                        })
                    }
                }
                $("#PostalCode").focus();
                if (validationMessage != "") {
                    setTimeout(function () {
                        var loader = $(".loadingoverlay");
                        loader.css("display", "none");
                    }, 150)
                    e.preventDefault();
                }
            }
        })
    }

    var progressBar = function (completedAttrs, totalAttrs,contactId) {
        if (completedAttrs && totalAttrs) {
            var strokeVal = 2.9;
            var percs = completedAttrs / totalAttrs * 100;
            var x = document.querySelector(`.progress-circle-${contactId}`);
            x.style.strokeDasharray = percs * (strokeVal) + ' 999';
        }
    }

    var clearSCEModelFields = function clearSCEModelFields() {
        $("#ChangeSCE").on("hidden.bs.modal", function () {
            $("#Settings_SCEMembershipID").val("");
            $("#Settings_SCEEmailAddress").val("");
        });

        $("#RemoveFromTrainingScheme").on("hidden.bs.modal", function () {
            $("#Settings_RemoveTraineeComments").val("");
        });
    }

    var stepByStepTour = function stepByStepTour(targetArr) {
        var availableTarget = [];
        if (targetArr.length > 0) {
            for (let i in targetArr) {
                if ($(`${targetArr[i].element}`).length > 0) {
                    availableTarget.push(targetArr[i]);
                }
            }
            const driverObj = window.driver({
                showProgress: false,
                allowClose: false,
                steps: availableTarget,
                popoverClass: "driverjs-theme",
                disableActiveInteraction: true,
                allowClose: true
            });

            driverObj.drive();
        }
    }

    return {
        init: function () {
            if ($(trilliumFormHelpersSelector).length) {
                bindHiddenFieldOnClick();
                bindShowLoadingSpinnerOnFormSubmit();
                bindClearFieldAndDisableOnChange();
                bindVisibilityToggleElemOnChange();
                disableGiftAidAddressFormValidation();
                toggleGiftaidFormValidation();
                bindHiddenFieldOnDropdownSelection();
                bindFormSubmitButton();
                bindTriggerSingleFieldValidation();
                bindVisibilityToggleElemOnClick();
                bindToggleRequiredTranslatedCertificateUpload();
                bindValidateSelfOnChange();
                scrollToOffsetTopSubmittedForm();
                bindIpdTraineeDetailsFormSubmitButton();
                bindQualificationAimEligiblityOnChange();
                bindDisabledToggleElemOnChange();
                bindChevronClick();
                bindDateSortArrowClick();
                bindHiddenFieldOnChange();
                bindAnnualAppraisalFormSubmissionCPDHoursValidation();
            }
            toggleReducedRateForm();
            printInfo();
            SponsorAttributeDisplayToggle();
            academicAssessmentHelper();
            groupClickHelper();
            customProgressCircle();
            disableRightClickOnLink();
            clearSCEModelFields();            
        },
        destroy: function () {
            if ($(trilliumFormHelpersSelector).length) {
                unbindVisibilityToggleElemOnChange();
            }
        },
        scrollToTopSubmittedForm: function (formSelector) {
            scrollToTopSubmittedForm(formSelector);
        },
        OptionalPostCodeFormValidation: function (formId, requiredMsg, InvalidCharMsg, CodeMaxLengthMsg) {
            OptionalPostCodeFormValidation(formId, requiredMsg, InvalidCharMsg, CodeMaxLengthMsg);
        },
        progressBar: function (completedAttrs, totalAttrs, contactId) {
            progressBar(completedAttrs, totalAttrs, contactId);
        },
        stepByStepTour: function (targetArr) {
            stepByStepTour(targetArr);
        }
    };
})(window.jQuery);

window.TrilliumFormHelpers = TrilliumFormHelpers;
